/** The defaults for the page size selector in the Pagination component. */
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
